/**
 * @file pages/LandingNewsLocal/constants.js
 * @copyright 2020 CBC/Radio-Canada. All rights reserved.
 */

// Number of card to show for each region
export const ITEM_COUNT = 1;
